import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { lighten, darken } from "polished"

const getBackgroundColor = (variant, useAlternativeVariant = false) => {
  switch (variant) {
    case "primary":
      return (props) => props.theme.colors.primary
    case "secondary":
      if (useAlternativeVariant) {
        return (props) => props.theme.colors.secondaryAlternative || props.theme.colors.secondary
      } else {
        return (props) => props.theme.colors.secondary
      }
    case "white":
      return "white"
    case "danger":
      return (props) => lighten(0.3, props.theme.colors.danger)
    case "transparent":
      return "transparent"
    case "warning":
      return (props) => lighten(0.3, props.theme.colors.warning)
    case "incompletion":
      return (props) => lighten(0.3, props.theme.colors.warning)
    default:
      return (props) => props.theme.colors.lightGrey
  }
}

const getHeightFromProps = (props) => {
  if (!!props.fixed && !!props.paddingless) {
    return "9rem"
  } else if (!!props.fixed) {
    return "7rem"
  } else {
    return "auto"
  }
}

export const StyledCard = styled.div`
  position: relative;
  background-color: ${({ variant, useAlternativeVariant }) => getBackgroundColor(variant, useAlternativeVariant)};
  ${({ simpleForm }) =>
    !simpleForm &&
    css`
      margin-bottom: 2rem;
    `}
  ${({ roundedOnMobile }) =>
    !!roundedOnMobile &&
    css`
      border-radius: 1rem;
    `}
  ${breakpoint("tablet")`
    border-radius: 1rem;
  `}
  height: ${(props) => getHeightFromProps(props)};

  ${({ image, theme }) =>
    image !== undefined &&
    css`
      background-size: cover;
      background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.primary} 100%),
        url("${image}");
    `}

  ${({ paddingless }) =>
    !paddingless &&
    css`
      padding: 2rem;
    `}

  ${({ paddingless }) =>
    !!paddingless &&
    css`
      padding: 0;
    `}

  ${({ marginless }) =>
    !!marginless &&
    css`
      margin: 0rem;
    `}

  ${({ paddinglessOnMobile }) =>
    !!paddinglessOnMobile &&
    breakpoint("mobile", "tablet")`
    padding: 0;
  `}

  ${({ pageMargin }) =>
    !!pageMargin &&
    css`
      margin: 0 1rem;

      ${breakpoint("tablet")`
      margin: 0;
    `}
    `}

  ${({ gridArea }) =>
    gridArea !== undefined &&
    css`
      ${breakpoint("tablet")`
      grid-area: ${gridArea};
    `}
    `}

    ${(props) =>
    props.desktopOnly &&
    css`
      display: none;

      ${breakpoint("tablet")`
      display: block;
    `}
    `}

    ${({ simpleFormContent, theme }) =>
    !!simpleFormContent &&
    css`
      width: 100%;
      padding: 24px 20px;
      border: 1px solid ${theme.colors.fields.border};
      border-radius: 16px;
    `}

      ${({ variant }) =>
    variant === "incompletion" &&
    css`
      border: 1px solid ${({ theme }) => darken(0.25, theme.colors.warning)};
      border-radius: 8px !important;
      padding: 16px 18px;
    `}
`
